import { LANGUAGE } from "@/common/utils/constants.js";

export const GOP_SEARCH_TRANSLATIONS = {
	[LANGUAGE.en.short]: {
		resultsFound: 'results found',
		searchInputPlaceHolder: 'Search for Sector Presentation or Offer',
		sectorPresentations: 'Presentations',
		searchPageSubtitle: 'Our expertise across key industries and domains',
		expand: 'Show All',
		collapse: 'Show Less',
		offers: 'Offers',
		offersSubtitle: 'Key strategic solutions & products by Akkodis',
		sortBy: 'Sort by',
		searchForRecognitionsPlaceholder: 'Search by recognition name',
		noResultsFound: 'No results found.',
		noResultsSubtitle: 'Filters may be restrictive. Please modify and try again.',
		clearFilters: 'Clear filters',
		customized: 'CUSTOMIZED',
		expandAll: 'Expand all',
		collapseAll: 'Collapse all',
		filter: 'Filter',
		standard: 'Standard',
		recentlySearched: "Recently Searched",
		globalSearchTrends: "Global Search Trends",
		suggestion: 'Suggestion',
		related: "Related",
		loading: 'Loading...',
		corporatePresentation: 'Corporate',
		industryPresentation: 'Industry',
		techpracticePresentation: 'Tech Practice',
		naPresentation: 'N/A',
		partnershipPresentation: 'Partnership Presentation',
		sectorAndOffers: "Presentations & Offers",
		noTitle: 'No Title',
		assetLanguage: 'Asset Language',
		viewDetails: 'View Details',
		searchAndSortResults: "Search and Sort results",
		findExpertise: "Find expertise or offers easily by using the search and sort your results as you need it.",
		buttonSkip: 'Skip tour',
		buttonPrevious: 'Previous',
		buttonNext: 'Next',
		buttonStop: 'Finish',
		narrowYourResults: 'Narrow your results using our standard filters',
		tip: "Tip",
		createAndApply: 'Create and apply your own customized filters. Create and manage your filters through “Create/Manage customized filters”',
		results: "Results",
		viewResults: 'Explore key strategic offers along with Country, Industry, Tech Practice and Partnership presentations',
		downloadReport: 'Download Report',
		generatingReport: "Generating Report. Please wait...",
		search: 'Search',
		clientSuccessStories: 'Client Success Stories',
		countryPresentation: "Country Presentation",
		copyProjectLink: 'Copy the offer\'s link',
		addToFavorite: "Add to favorite",
		removeFromFavorite: "Remove from favorite",
		archived: "ARCHIVED",
		draft: "DRAFT",
		archivedDraft: "ARCHIVED DRAFT",
		relatedOffers: "Related Offers",
	},
	[LANGUAGE.de.short]: {
		resultsFound: 'ergebnisse gefunden',
		searchInputPlaceHolder: 'Suche nach Branchenpräsentation oder Angebot',
		sectorPresentations: 'Präsentationen',
		searchPageSubtitle: 'Unsere Expertise in wichtigen Branchen und Bereichen',
		expand: 'Alle anzeigen',
		collapse: 'Weniger anzeigen',
		offers: 'Angebote',
		offersSubtitle: 'Wichtige strategische Lösungen & Produkte von Akkodis',
		sortBy: 'Sortieren nach',
		searchForRecognitionsPlaceholder: 'Suche nach Erkennungsnamen',
		noResultsFound: 'Keine Ergebnisse gefunden.',
		noResultsSubtitle: 'Die Filter sind möglicherweise zu restriktiv. Bitte ändern Sie sie und versuchen Sie es erneut.',
		clearFilters: 'Filter löschen',
		customized: 'BENUTZERDEFINIERT',
		expandAll: 'Alle ausklappen',
		collapseAll: 'Alle ausblenden',
		filter: 'Filter',
		standard: 'Standard',
		recentlySearched: "Zuletzt gesucht",
		globalSearchTrends: 'Globale Suchtrends',
		suggestion: 'Anregung',
		related: "Verwandt",
		loading: 'Laden...',
		corporatePresentation: 'Unternehmen',
		industryPresentation: 'Branche',
		techpracticePresentation: 'Tech-Praktiken',
		naPresentation: 'N/A',
		sectorAndOffers: "Präsentationen & Angebote",
		noTitle: 'Kein Titel',
		assetLanguage: 'Asset-Sprache',
		viewDetails: 'Details anzeigen',
		searchAndSortResults: "Such- und Sortierergebnisse",
		findExpertise: "Finden Sie Expertise oder Angebote einfach, indem Sie die Suche verwenden und sortieren Sie Ihre Ergebnisse nach Bedarf.",
		buttonSkip: 'Tour überspringen',
		buttonPrevious: 'Vorherige',
		buttonNext: 'Nächste',
		buttonStop: 'Fertigstellen',
		narrowYourResults: 'Verfeinern Sie Ihre Ergebnisse mit unseren Standardfiltern',
		tip: "Tipp",
		createAndApply: 'Erstellen und anwenden Ihrer eigenen benutzerdefinierten Filter. Erstellen und verwalten Sie Ihre Filter über "Erstellen/Verwalten benutzerdefinierter Filter"',
		results: "Ergebnisse",
		viewResults: 'Entdecken Sie wichtige strategische Angebote sowie Präsentationen zu Ländern, Branchen, Technologiebereichen und Partnerschaften.',
		downloadReport: 'Bericht herunterladen',
		generatingReport: "Bericht wird generiert. Bitte warten...",
		search: 'Suche',
		clientSuccessStories: 'Kunden-Erfolgsgeschichten',
		countryPresentation: "Länderpräsentation",
		copyProjectLink: "Angebotslink kopieren",
		addToFavorite: "Zu Favoriten hinzufügen",
		removeFromFavorite: "Aus Favoriten entfernen",
		archived: "ARCHIVIERT",
		draft: "ENTWURF",
		archivedDraft: "ARCHIVIERTER ENTWURF",
		relatedOffers: "Verwandte Angebote",
	},
	[LANGUAGE.fr.short]: {
		resultsFound: 'résultats trouvés',
		searchInputPlaceHolder: 'Rechercher une présentation sectorielle ou une offre',
		sectorPresentations: 'Présentations',
		searchPageSubtitle: 'Notre expertise dans les secteurs et domaines clés',
		expand: 'Afficher tout',
		collapse: 'Afficher moins',
		offers: 'Offres',
		offersSubtitle: 'Solutions et produits stratégiques clés d\'Akkodis',
		sortBy: 'Trier par',
		searchForRecognitionsPlaceholder: 'Rechercher par nom de célébrité',
		noResultsFound: 'Aucun résultat trouvé.',
		noResultsSubtitle: 'Les filtres peuvent être trop restrictifs. Veuillez les modifier et réessayer.',
		clearFilters: 'Effacer les filtres',
		customized: 'PERSONNALISÉ',
		expandAll: 'Tout développer',
		collapseAll: "Тout s'effondrer",
		filter: 'Filtrer',
		standard: 'Standard',
		recentlySearched: 'Recherches récentes',
		globalSearchTrends: 'tendances mondiales de recherche',
		suggestion: 'suggestion',
		related: 'En rapport',
		loading: 'chargement...',
		corporatePresentation: 'Entreprise',
		industryPresentation: 'Succursale',
		techpracticePresentation: 'Pratique technique',
		naPresentation: 'N/A',
		sectorAndOffers: "Présentations & Offres",
		noTitle: 'Pas de titre',
		assetLanguage: 'Langue de l\'actif',
		viewDetails: 'Voir les détails',
		searchAndSortResults: "Rechercher et trier les résultats",
		findExpertise: "Trouvez facilement une expertise ou des offres en utilisant la recherche et triez vos résultats selon vos besoins.",
		buttonSkip: 'Passer la visite',
		buttonPrevious: 'Précédent',
		buttonNext: 'Suivant',
		buttonStop: 'Terminer',
		narrowYourResults: 'Affinez vos résultats à l\'aide de nos filtres standard',
		tip: "Conseil",
		createAndApply: 'Créez et appliquez vos propres filtres personnalisés. Créez et gérez vos filtres via "Créer/Gérer des filtres personnalisés"',
		results: "Résultats",
		viewResults: 'Découvrez des offres stratégiques clés ainsi que des présentations sur les pays, les secteurs, les domaines technologiques et les partenariats.',
		downloadReport: 'Télécharger le rapport',
		generatingReport: "Génération du rapport. Veuillez patienter...",
		search: 'Recherche',
		clientSuccessStories: 'Témoignages clients',
		countryPresentation: "Présentation du pays",
		copyProjectLink: "Copier le lien de l'offre",
		addToFavorite: "Ajouter aux favoris",
		removeFromFavorite: "Retirer des favoris",
		archived: "ARCHIVÉ",
		draft: "BROUILLON",
		archivedDraft: "BROUILLON ARCHIVÉ",
		relatedOffers: "Offres connexes"
	},
	[LANGUAGE.it.short]: {
		resultsFound: 'risultati trovati',
		searchInputPlaceHolder: 'Cerca per presentazione di settore o offerta',
		sectorPresentations: 'Presentazioni',
		searchPageSubtitle: 'La nostra esperienza nei settori e domini chiave',
		expand: 'Mostra tutto',
		collapse: 'Mostra meno',
		offers: 'Offerte',
		offersSubtitle: 'Soluzioni e prodotti strategici chiave di Akkodis',
		sortBy: 'Ordina per',
		searchForRecognitionsPlaceholder: 'Cerca per nome di riconoscimento',
		noResultsFound: 'Nessun risultato trovato.',
		noResultsSubtitle: 'I filtri potrebbero essere troppo restrittivi. Modificali e riprova.',
		clearFilters: 'Cancella filtri',
		customized: 'PERSONALIZZATO',
		expandAll: 'Espandi tutto',
		collapseAll: 'Nascondi tutto',
		filter: 'Filtra',
		standard: 'Standard',
		recentlySearched: 'Ricerche recenti',
		globalSearchTrends: 'Globale Suchtrends',
		suggestion: 'Anregung',
		related: "Verwandt",
		loading: 'Laden...',
		corporatePresentation: 'Perseguire',
		industryPresentation: 'Industria',
		techpracticePresentation: 'Pratica tecnologica',
		naPresentation: 'N/A',
		sectorAndOffers: "Presentazioni & Offerte",
		noTitle: 'Nessun titolo',
		assetLanguage: 'Lingua dell\'asset',
		viewDetails: 'Visualizza dettagli',
		searchAndSortResults: "Cerca e ordina i risultati",
		findExpertise: "Trova facilmente competenze o offerte utilizzando la ricerca e ordina i tuoi risultati secondo necessità.",
		buttonSkip: 'Salta il tour',
		buttonPrevious: 'Precedente',
		buttonNext: 'Successivo',
		buttonStop: 'Finire',
		narrowYourResults: 'Restringi i tuoi risultati usando i nostri filtri standard',
		tip: "Suggerimento",
		createAndApply: 'Crea e applica i tuoi filtri personalizzati. Crea e gestisci i tuoi filtri tramite "Crea/Gestisci filtri personalizzati"',
		results: "Risultati",
		viewResults: 'Esplora le principali offerte strategiche insieme a presentazioni di Paese, Settore, Pratica tecnologica e Partnership',
		downloadReport: 'Scarica il rapporto',
		generatingReport: "Generazione del rapporto. Attendere prego...",
		search: 'Cerca',
		clientSuccessStories: 'Storie di successo dei clienti',
		countryPresentation: "Presentazione del paese",
		copyProjectLink: "Copia il link dell'offerta",
		addToFavorite: "Aggiungi ai preferiti",
		removeFromFavorite: "Rimuovi dai preferiti",
		archived: "ARCHIVIATO",
		draft: "BOZZA",
		archivedDraft: "BOZZA ARCHIVIATA",
		relatedOffers: "Offerte correlate"
	},
	[LANGUAGE.ja.short]: {
		resultsFound: '結果が見つかりました',
		searchInputPlaceHolder: 'セクタープレゼンテーションまたはオファーで検索',
		sectorPresentations: 'プレゼンテーション',
		searchPageSubtitle: '主要な業界やドメインにおける私たちの専門知識',
		expand: 'すべて表示',
		collapse: '少なく表示',
		offers: 'オファー',
		offersSubtitle: 'Akkodisの主要な戦略的ソリューションと製品',
		sortBy: '並べ替え',
		searchForRecognitionsPlaceholder: '表彰名で検索',
		noResultsFound: '結果が見つかりませんでした。',
		noResultsSubtitle: 'フィルターが厳しすぎる可能性があります。変更して再試行してください。',
		clearFilters: 'フィルターをクリア',
		customized: 'カスタム',
		expandAll: 'すべて展開',
		collapseAll: 'すべて折りたたむ',
		filter: 'フィルター',
		standard: '標準',
		recentlySearched: '最近検索された',
		globalSearchTrends: '世界の検索トレンド',
		suggestion: '提案',
		related: '関連',
		loading: '読み込み中...',
		corporatePresentation: '企業',
		industryPresentation: '業界',
		techpracticePresentation: 'テックプラクティス',
		naPresentation: 'N/A',
		sectorAndOffers: "セクタープレゼンテーション & オファー",
		noTitle: 'タイトルなし',
		assetLanguage: 'アセットの言語',
		viewDetails: '詳細を見る',
		searchAndSortResults: "検索と並べ替えの結果",
		findExpertise: "検索を使用して専門知識やオファーを簡単に見つけ、必要に応じて結果を並べ替えます。",
		buttonSkip: 'ツアーをスキップ',
		buttonPrevious: '前',
		buttonNext: '次',
		buttonStop: '終了',
		narrowYourResults: '標準フィルターを使用して結果を絞り込む',
		tip: "ヒント",
		createAndApply: '独自のカスタマイズされたフィルターを作成して適用します。 「カスタムフィルターの作成/管理」を通じてフィルターを作成および管理します',
		results: "結果",
		viewResults: '国、業界、テックプラクティス、パートナーシップのプレゼンテーションとともに、主要な戦略的オファーを確認する',
		downloadReport: 'レポートをダウンロード',
		generatingReport: "レポートを生成しています。しばらくお待ちください...",
		search: '検索',
		clientSuccessStories: '導入事例',
		countryPresentation: "国のプレゼンテーション",
		copyProjectLink: "オファーのリンクをコピー",
		addToFavorite: "お気に入りに追加",
		removeFromFavorite: "お気に入りから削除",
		archived: "アーカイブ済み",
		draft: "下書き",
		archivedDraft: "アーカイブ済みの下書き",
		relatedOffers: "関連オファー"
	},
	[LANGUAGE.es.short]: {
		resultsFound: 'resultados encontrados',
		searchInputPlaceHolder: 'Buscar por presentación sectorial u oferta',
		sectorPresentations: 'Presentaciones',
		searchPageSubtitle: 'Buscar por experiencia u oferta',
		expand: 'Mostrar todo',
		collapse: 'Mostrar menos',
		offers: 'Ofertas',
		offersSubtitle: 'Soluciones y productos estratégicos clave de Akkodis',
		sortBy: 'Ordenar por',
		searchForRecognitionsPlaceholder: 'Buscar por nombre de reconocimiento',
		noResultsFound: 'No se han encontrado resultados.',
		noResultsSubtitle: 'Los filtros pueden ser demasiado restrictivos. Modifíquelos y vuelva a intentarlo.',
		clearFilters: 'Borrar filtros',
		customized: 'PERSONALIZADO',
		expandAll: 'Expandir todo',
		collapseAll: 'Colapsar todo',
		filter: 'Filtrar',
		standard: 'Estándar',
		recentlySearched: 'Buscado recientemente',
		globalSearchTrends: 'Globale Suchtrends',
		suggestion: 'Anregung',
		related: "Verwandt",
		loading: 'Laden...',
		corporatePresentation: 'Buscar',
		industryPresentation: 'Industria',
		techpracticePresentation: 'Prácticas técnicas',
		naPresentation: 'N/A',
		sectorAndOffers: "Presentaciones & Ofertas",
		noTitle: 'Sin título',
		assetLanguage: 'Idioma del activo',
		viewDetails: 'Ver detalles',
		searchAndSortResults: "Buscar y ordenar resultados",
		findExpertise: "Encuentre experiencia u ofertas fácilmente utilizando la búsqueda y ordene sus resultados según lo necesite.",
		buttonSkip: 'Saltar tour',
		buttonPrevious: 'Anterior',
		buttonNext: 'Siguiente',
		buttonStop: 'Terminar',
		narrowYourResults: 'Restringe tus resultados usando nuestros filtros estándar',
		tip: "Consejo",
		createAndApply: 'Cree y aplique sus propios filtros personalizados. Cree y administre sus filtros a través de "Crear/Administrar filtros personalizados"',
		results: "Resultados",
		viewResults: 'Explore ofertas estratégicas clave junto con presentaciones de país, industria, prácticas técnicas y asociaciones',
		downloadReport: 'Descargar informe',
		generatingReport: "Generando informe. Por favor espera...",
		search: 'Buscar',
		clientSuccessStories: 'Casos de éxito de clientes',
		countryPresentation: "Presentación del país",
		copyProjectLink: "Copiar el enlace de la oferta",
		addToFavorite: "Añadir a favoritos",
		removeFromFavorite: "Eliminar de favoritos",
		archived: "ARCHIVADO",
		draft: "BORRADOR",
		archivedDraft: "BORRADOR ARCHIVADO",
		relatedOffers: "Ofertas relacionadas"
	}
}
